import type { SessionStepModule } from '../types';
import { BankDetail } from './BankDetail';
import { BankStepRunner } from './BankStepRunner';
import { isBankStep } from './bank.utils';

// Bank Account Verification step module (SEBI spec §8 — Penny Drop / Penniless,
// Basic / Advance).
export const bankStepModule: SessionStepModule = {
  key: 'bank',
  matches: isBankStep,
  Runner: BankStepRunner,
  Detail: BankDetail,
};
